<template>
  <div class="bg-white align-items-center justify-content-center cursor-pointer box-shadow-light-aff"
       :class="buttonClass"
       :style="buttonStyle"
       @click.stop="$emit('share')"
       v-b-tooltip.hover="$t('hotel.action.share')">
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="18" cy="5" r="3"></circle>
      <circle cx="6" cy="12" r="3"></circle>
      <circle cx="18" cy="19" r="3"></circle>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'ProductShareButton',
    props: {
      size: {
        type: Number,
        default: 28
      },
      offset: {
        type: Number,
        default: 8
      },
      iconSize: {
        type: Number,
        default: 14
      },
      inline: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      buttonClass() {
        return this.inline ? 'd-inline-flex' : 'position-absolute d-flex'
      },
      buttonStyle() {
        const style = {
          width: `${this.size}px`,
          height: `${this.size}px`,
          borderRadius: '50%'
        }
        if (this.inline) return style

        style.top = `${this.offset}px`
        style.right = `${this.offset}px`
        style.zIndex = 5
        return style
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/hotel/concierge/general/ProductShareButton.vue